import { environment } from '@env/environment';
import { I18nConfig } from '@lib/interfaces';

/**
 * i18n（国際化対応）構成
 */

const localTestList =
  environment.envName === 'local'
    ? [
        {
          prefix: 'hello_world/',
        },
        {
          prefix: 'test/',
        },
      ]
    : [];

export const I18N_CONFIG: I18nConfig = {
  // サポート可能な言語定義
  supportedLocales: {
    ja: 'ja', // 日本語
    en: 'en', // 英語
    cn: 'zh-CN', // 中国語(簡体字)
    hk: 'zh-HK', // 中国語(繁体字/香港)
    tw: 'zh-TW', // 中国語(繁体字/台湾)
    ko: 'ko', // 韓国語
    th: 'th', // タイ語
    vn: 'vi', // ベトナム語
    id: 'id', // インドネシア語
    fr: 'fr', // フランス語
    de: 'de', // ドイツ語
    es: 'es', // スペイン語
    ru: 'ru', // ロシア語
    it: 'it', // イタリア語
    sv: 'sv', // スウェーデン語
    tr: 'tr', // トルコ語
  },
  // デフォルト言語
  defaultLanguage: 'ja',
  // ロードするファイルのリスト
  // FIXME: 各APPごとに指定する
  loadFileList: [
    ...localTestList,
    {
      prefix: 'm_static_message/',
    },
    {
      prefix: 'm_error_message/',
    },
    {
      prefix: 'm_dynamic_message/',
    },
    {
      prefix: 'm_list_data/',
    },
    {
      prefix: 'm_country_i18n/',
    },
    {
      prefix: 'm_service_contents_i18n/',
    },
    {
      prefix: 'm_ff_priority_code_i18n/',
    },
    {
      prefix: 'm_country_i18n/',
    },
    {
      prefix: 'm_airport_i18n/',
    },
    {
      prefix: 'm_airline_i18n/',
    },
  ],
};
